(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  // Quantity increase/decrease buttons
  document.querySelectorAll('.quantity-selector__button').forEach(button => {
    button.addEventListener('click', function() {
      const action = this.dataset.action;
      const line = this.dataset.line;
      const input = document.getElementById(`quantity-${line}`);
      let quantity = parseInt(input.value);

      if (action === 'increase') {
        quantity++;
      } else if (action === 'decrease' && quantity > 0) {
        quantity--;
      }

      input.value = quantity;
      updateCart();
    });
  });

  // Remove item buttons
  document.querySelectorAll('.cart-item__remove').forEach(button => {
    button.addEventListener('click', function() {
      const line = this.dataset.line;
      const input = document.getElementById(`quantity-${line}`);
      input.value = 0;
      updateCart();
    });
  });

  // Update cart function
  function updateCart() {
    document.getElementById('cart-form').submit();
  }

  // Allow direct input changes
  document.querySelectorAll('.quantity-selector__input').forEach(input => {
    input.addEventListener('change', function() {
      if (parseInt(this.value) < 0) {
        this.value = 0;
      }
      updateCart();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  // Vault Archive filter
  (function() {
    var vaGrid = document.getElementById('va-grid');
    if (!vaGrid) return;
    var vaButtons = document.querySelectorAll('.va__filter-btn');
    var vaCards = document.querySelectorAll('.va__card');
    var vaCount = document.getElementById('va-count');

    vaButtons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var filter = this.dataset.vaFilter;
        vaButtons.forEach(function(b) { b.classList.remove('va__filter-btn--active'); });
        this.classList.add('va__filter-btn--active');
        var visible = 0;
        vaCards.forEach(function(card) {
          var show = filter === 'all' || card.dataset.vaType === filter;
          card.classList.toggle('va-hidden', !show);
          if (show) visible++;
        });
        if (vaCount) vaCount.textContent = visible;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // Mobile menu toggle
  const mobileToggle = document.getElementById('mobile-menu-toggle');
  const mobileMenu = document.getElementById('mobile-menu');

  if (mobileToggle && mobileMenu) {
    mobileToggle.addEventListener('click', function() {
      const isExpanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', !isExpanded);
      mobileMenu.classList.toggle('active');
    });

    // Close mobile menu when clicking on a link
    const mobileLinks = mobileMenu.querySelectorAll('a');
    mobileLinks.forEach(function(link) {
      link.addEventListener('click', function() {
        mobileToggle.setAttribute('aria-expanded', 'false');
        mobileMenu.classList.remove('active');
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll('[data-ht-carousel]');
    if (!roots.length) return;

    roots.forEach(function (root) {
      var track = root.querySelector('[data-carousel-track]');
      var slides = Array.from(root.querySelectorAll('.carousel-images__slide'));
      var prevBtn = root.querySelector('[data-carousel-prev]');
      var nextBtn = root.querySelector('[data-carousel-next]');
      var slideCount = slides.length;
      if (slideCount < 2) return;

      var currentIndex = 0;
      var autoplayInterval = null;
      var autoplayDelay = (parseFloat(root.dataset.autoplay) || 5) * 1000;
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function updatePositions() {
        slides.forEach(function (slide, i) {
          slide.classList.remove('is-active');

          var diff = i - currentIndex;
          if (diff > slideCount / 2) diff -= slideCount;
          if (diff < -slideCount / 2) diff += slideCount;

          if (diff === 0) {
            slide.setAttribute('data-position', 'current');
            slide.classList.add('is-active');
          } else if (diff === -1) {
            slide.setAttribute('data-position', 'prev');
          } else if (diff === 1) {
            slide.setAttribute('data-position', 'next');
          } else {
            slide.setAttribute('data-position', 'hidden');
          }
        });
      }

      function goToSlide(index) {
        if (index < 0) index = slideCount - 1;
        if (index >= slideCount) index = 0;
        currentIndex = index;
        updatePositions();
      }

      function nextSlide() { goToSlide(currentIndex + 1); }
      function prevSlide() { goToSlide(currentIndex - 1); }

      function startAutoplay() {
        stopAutoplay();
        if (reduceMotion || autoplayDelay <= 0) return;
        autoplayInterval = window.setInterval(nextSlide, autoplayDelay);
      }

      function stopAutoplay() {
        if (!autoplayInterval) return;
        window.clearInterval(autoplayInterval);
        autoplayInterval = null;
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          prevSlide();
          startAutoplay();
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          nextSlide();
          startAutoplay();
        });
      }

      // Click the slide above or below to bring it forward
      slides.forEach(function (slide, i) {
        slide.addEventListener('click', function () {
          if (i === currentIndex) return;
          goToSlide(i);
          startAutoplay();
        });
      });

      root.addEventListener('mouseenter', stopAutoplay);
      root.addEventListener('mouseleave', startAutoplay);
      root.addEventListener('focusin', stopAutoplay);
      root.addEventListener('focusout', startAutoplay);

      // Vertical swipe, matching the carousel's own axis
      var touchStartY = 0;
      if (track) {
        track.addEventListener('touchstart', function (e) {
          touchStartY = e.changedTouches[0].screenY;
          stopAutoplay();
        }, { passive: true });

        track.addEventListener('touchend', function (e) {
          var diff = touchStartY - e.changedTouches[0].screenY;
          if (Math.abs(diff) > 50) {
            if (diff > 0) { nextSlide(); } else { prevSlide(); }
          }
          startAutoplay();
        }, { passive: true });
      }

      // Only run while the hero is on screen
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) { startAutoplay(); } else { stopAutoplay(); }
          });
        }, { threshold: 0.2 }).observe(root);
      }

      updatePositions();
      startAutoplay();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  // Product Gallery with Carousel and Zoom
  document.addEventListener('DOMContentLoaded', function() {
    // Elements
    const thumbnails = document.querySelectorAll('.product-detail__thumbnail');
    const mainImageContainer = document.getElementById('product-main-image');
    const mainImage = mainImageContainer ? mainImageContainer.querySelector('img') : null;
    const prevBtn = document.querySelector('.product-detail__nav--prev');
    const nextBtn = document.querySelector('.product-detail__nav--next');
    const imageCounter = document.getElementById('current-image-index');
    const zoomTrigger = document.querySelector('.product-detail__zoom-trigger');

    // Zoom modal elements
    const zoomModal = document.getElementById('zoom-modal');
    const zoomImageContainer = document.getElementById('zoom-image-container');
    const zoomImage = zoomImageContainer ? zoomImageContainer.querySelector('img') : null;
    const zoomClose = document.getElementById('zoom-modal-close');
    const zoomPrevBtn = document.querySelector('.product-detail__zoom-nav--prev');
    const zoomNextBtn = document.querySelector('.product-detail__zoom-nav--next');
    const zoomThumbnails = document.querySelectorAll('.product-detail__zoom-thumb');

    /* ------------------------------------------------------------------
       Zoom viewport: wheel / pinch / click magnification with drag-to-pan.
       State is a scale plus a translation; the transform is
       translate(x, y) scale(s) with a centred transform-origin.
    ------------------------------------------------------------------ */
    var zoomLevelEl = document.getElementById('zoom-level-indicator');
    var zoomHintEl = document.getElementById('zoom-hint');
    var ZOOM_MIN = 1;
    var ZOOM_MAX = 4;
    var ZOOM_CLICK_TARGET = 2.5;
    var zoomScale = 1;
    var zoomX = 0;
    var zoomY = 0;
    var isPanning = false;
    var didPan = false;
    var panStartX = 0, panStartY = 0, panOriginX = 0, panOriginY = 0;
    var pinchStartDist = 0, pinchStartScale = 1;

    function isZoomed() {
      return zoomScale > 1.01;
    }

    function clampValue(value, min, max) {
      return Math.min(Math.max(value, min), max);
    }

    function constrainPan() {
      if (!zoomImage) return;
      var frameW = zoomImageContainer ? zoomImageContainer.clientWidth : window.innerWidth;
      var frameH = zoomImageContainer ? zoomImageContainer.clientHeight : window.innerHeight;
      // Never let the image be dragged past its own edges.
      var maxX = Math.max(0, (zoomImage.clientWidth * zoomScale - frameW) / 2);
      var maxY = Math.max(0, (zoomImage.clientHeight * zoomScale - frameH) / 2);
      zoomX = clampValue(zoomX, -maxX, maxX);
      zoomY = clampValue(zoomY, -maxY, maxY);
    }

    function applyZoom(animate) {
      if (!zoomImage) return;
      constrainPan();
      zoomImage.style.transition = animate ? 'transform 220ms cubic-bezier(0.22, 1, 0.36, 1)' : 'none';
      zoomImage.style.transform = 'translate(' + zoomX + 'px, ' + zoomY + 'px) scale(' + zoomScale + ')';
      zoomImage.style.cursor = isZoomed() ? (isPanning ? 'grabbing' : 'grab') : 'zoom-in';

      if (zoomLevelEl) {
        zoomLevelEl.textContent = zoomScale.toFixed(1) + '\u00d7';
        zoomLevelEl.classList.toggle('is-visible', isZoomed());
      }
      if (zoomHintEl) {
        zoomHintEl.classList.toggle('is-hidden', isZoomed());
      }
    }

    function resetZoomView() {
      zoomScale = 1;
      zoomX = 0;
      zoomY = 0;
      isPanning = false;
      didPan = false;
      applyZoom(false);
    }

    // Scale toward a point so whatever is under the cursor stays put.
    function zoomToPoint(nextScale, clientX, clientY, animate) {
      if (!zoomImage) return;
      nextScale = clampValue(nextScale, ZOOM_MIN, ZOOM_MAX);
      if (nextScale === zoomScale) return;

      var rect = zoomImage.getBoundingClientRect();
      var offsetX = clientX - (rect.left + rect.width / 2);
      var offsetY = clientY - (rect.top + rect.height / 2);
      var ratio = nextScale / zoomScale;

      zoomX += offsetX * (1 - ratio);
      zoomY += offsetY * (1 - ratio);
      zoomScale = nextScale;

      if (!isZoomed()) {
        zoomX = 0;
        zoomY = 0;
      }
      applyZoom(animate !== false);
    }

    if (zoomImageContainer) {
      // Wheel / trackpad
      zoomImageContainer.addEventListener('wheel', function(e) {
        if (!zoomModal || !zoomModal.classList.contains('active')) return;
        e.preventDefault();
        var factor = Math.exp(-e.deltaY * 0.0022);
        zoomToPoint(zoomScale * factor, e.clientX, e.clientY, false);
      }, { passive: false });

      // Click toggles between fit and magnified, anchored where you clicked
      zoomImageContainer.addEventListener('click', function(e) {
        if (e.target !== zoomImage) return;
        if (didPan) { didPan = false; return; }
        if (isZoomed()) {
          resetZoomView();
        } else {
          zoomToPoint(ZOOM_CLICK_TARGET, e.clientX, e.clientY, true);
        }
      });

      // Drag to pan (mouse)
      zoomImageContainer.addEventListener('mousedown', function(e) {
        if (!isZoomed() || e.target !== zoomImage) return;
        e.preventDefault();
        isPanning = true;
        didPan = false;
        panStartX = e.clientX;
        panStartY = e.clientY;
        panOriginX = zoomX;
        panOriginY = zoomY;
        applyZoom(false);
      });

      window.addEventListener('mousemove', function(e) {
        if (!isPanning) return;
        var dx = e.clientX - panStartX;
        var dy = e.clientY - panStartY;
        if (Math.abs(dx) > 3 || Math.abs(dy) > 3) didPan = true;
        zoomX = panOriginX + dx;
        zoomY = panOriginY + dy;
        applyZoom(false);
      });

      window.addEventListener('mouseup', function() {
        if (!isPanning) return;
        isPanning = false;
        applyZoom(false);
      });

      // Touch: one finger pans while zoomed, two fingers pinch
      zoomImageContainer.addEventListener('touchstart', function(e) {
        if (e.touches.length === 2) {
          var dx = e.touches[0].clientX - e.touches[1].clientX;
          var dy = e.touches[0].clientY - e.touches[1].clientY;
          pinchStartDist = Math.sqrt(dx * dx + dy * dy);
          pinchStartScale = zoomScale;
          isPanning = false;
        } else if (e.touches.length === 1 && isZoomed()) {
          isPanning = true;
          didPan = false;
          panStartX = e.touches[0].clientX;
          panStartY = e.touches[0].clientY;
          panOriginX = zoomX;
          panOriginY = zoomY;
        }
      }, { passive: true });

      zoomImageContainer.addEventListener('touchmove', function(e) {
        if (e.touches.length === 2 && pinchStartDist > 0) {
          e.preventDefault();
          var dx = e.touches[0].clientX - e.touches[1].clientX;
          var dy = e.touches[0].clientY - e.touches[1].clientY;
          var dist = Math.sqrt(dx * dx + dy * dy);
          var midX = (e.touches[0].clientX + e.touches[1].clientX) / 2;
          var midY = (e.touches[0].clientY + e.touches[1].clientY) / 2;
          zoomToPoint(pinchStartScale * (dist / pinchStartDist), midX, midY, false);
          didPan = true;
        } else if (isPanning && e.touches.length === 1) {
          e.preventDefault();
          var mdx = e.touches[0].clientX - panStartX;
          var mdy = e.touches[0].clientY - panStartY;
          if (Math.abs(mdx) > 3 || Math.abs(mdy) > 3) didPan = true;
          zoomX = panOriginX + mdx;
          zoomY = panOriginY + mdy;
          applyZoom(false);
        }
      }, { passive: false });

      zoomImageContainer.addEventListener('touchend', function(e) {
        if (e.touches.length === 0) {
          pinchStartDist = 0;
          isPanning = false;
          // A pinch that ends near 1x should settle exactly at fit.
          if (zoomScale < 1.05 && isZoomed() === false) resetZoomView();
        }
      }, { passive: true });
    }

    // State
    var currentIndex = 0;
    var totalImages = thumbnails.length || 1;

    // Preload all product images for instant switching
    thumbnails.forEach(function(thumb) {
      var img = new Image();
      img.src = thumb.getAttribute('data-image-url');
      var imgLarge = new Image();
      imgLarge.src = thumb.getAttribute('data-image-url-large');
    });

    // Update main image display
    function updateMainImage(index) {
      if (index < 0) index = totalImages - 1;
      if (index >= totalImages) index = 0;
      currentIndex = index;

      var thumbnail = thumbnails[currentIndex];
      if (thumbnail && mainImage) {
        var imageUrl = thumbnail.getAttribute('data-image-url');
        // Clear srcset so browser uses src instead
        mainImage.removeAttribute('srcset');
        mainImage.src = imageUrl;

        // Update active states
        thumbnails.forEach(function(t) { t.classList.remove('active'); });
        thumbnail.classList.add('active');

        // Update counter
        if (imageCounter) {
          imageCounter.textContent = currentIndex + 1;
        }
      }
    }

    // Update zoom image display
    function updateZoomImage(index) {
      if (index < 0) index = totalImages - 1;
      if (index >= totalImages) index = 0;
      currentIndex = index;

      var thumbnail = thumbnails[currentIndex];
      if (thumbnail && zoomImage) {
        var largeUrl = thumbnail.getAttribute('data-image-url-large');
        // Clear srcset so browser uses src instead
        zoomImage.removeAttribute('srcset');
        zoomImage.src = largeUrl;
        resetZoomView();

        // Update zoom thumbnail active states
        zoomThumbnails.forEach(function(t) { t.classList.remove('active'); });
        if (zoomThumbnails[currentIndex]) {
          zoomThumbnails[currentIndex].classList.add('active');
        }

        // Also sync main gallery
        thumbnails.forEach(function(t) { t.classList.remove('active'); });
        thumbnail.classList.add('active');

        if (imageCounter) {
          imageCounter.textContent = currentIndex + 1;
        }
      }
    }

    // Thumbnail click handlers
    thumbnails.forEach(function(thumbnail, index) {
      thumbnail.addEventListener('click', function() {
        updateMainImage(index);
      });
    });

    // Carousel navigation
    if (prevBtn) {
      prevBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        updateMainImage(currentIndex - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        updateMainImage(currentIndex + 1);
      });
    }

    // Open zoom modal
    function openZoomModal() {
      if (zoomModal) {
        // Update zoom image to current
        var thumbnail = thumbnails[currentIndex];
        if (thumbnail && zoomImage) {
          var largeUrl = thumbnail.getAttribute('data-image-url-large');
          zoomImage.src = largeUrl;

          // Sync zoom thumbnails
          zoomThumbnails.forEach(function(t) { t.classList.remove('active'); });
          if (zoomThumbnails[currentIndex]) {
            zoomThumbnails[currentIndex].classList.add('active');
          }
        }

        resetZoomView();
        zoomModal.classList.add('active');
        document.body.style.overflow = 'hidden';
      }
    }

    // Close zoom modal
    function closeZoomModal() {
      if (zoomModal) {
        zoomModal.classList.remove('active');
        document.body.style.overflow = 'auto';
        resetZoomView();

        // Sync main image when closing
        if (mainImage && thumbnails[currentIndex]) {
          mainImage.src = thumbnails[currentIndex].getAttribute('data-image-url');
        }
      }
    }

    // Zoom trigger click
    if (zoomTrigger) {
      zoomTrigger.addEventListener('click', function(e) {
        e.stopPropagation();
        openZoomModal();
      });
    }

    // Main image click opens zoom (but not when clicking nav buttons)
    if (mainImageContainer) {
      mainImageContainer.addEventListener('click', function(e) {
        // Don't open zoom if clicking on navigation or zoom trigger
        if (e.target.closest('.product-detail__nav') ||
            e.target.closest('.product-detail__zoom-trigger')) {
          return;
        }
        // Only open zoom when clicking the actual image
        if (e.target === mainImage || e.target.classList.contains('product-detail__main-img')) {
          openZoomModal();
        }
      });
    }

    // Zoom close button
    if (zoomClose) {
      zoomClose.addEventListener('click', closeZoomModal);
    }

    // Close zoom on backdrop click
    if (zoomModal) {
      zoomModal.addEventListener('click', function(e) {
        if (e.target === zoomModal && !didPan) {
          closeZoomModal();
        }
        didPan = false;
      });
    }

    // Zoom navigation
    if (zoomPrevBtn) {
      zoomPrevBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        updateZoomImage(currentIndex - 1);
      });
    }

    if (zoomNextBtn) {
      zoomNextBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        updateZoomImage(currentIndex + 1);
      });
    }

    // Zoom thumbnail clicks
    zoomThumbnails.forEach(function(thumb, index) {
      thumb.addEventListener('click', function(e) {
        e.stopPropagation();
        updateZoomImage(index);
      });
    });

    // Keyboard navigation
    document.addEventListener('keydown', function(e) {
      var isZoomOpen = zoomModal && zoomModal.classList.contains('active');

      if (e.key === 'Escape') {
        if (isZoomOpen) {
          closeZoomModal();
        }
      }

      if (e.key === 'ArrowLeft') {
        if (isZoomOpen) {
          updateZoomImage(currentIndex - 1);
        }
      }

      if (e.key === 'ArrowRight') {
        if (isZoomOpen) {
          updateZoomImage(currentIndex + 1);
        }
      }
    });

    // Touch swipe support for zoom modal
    var touchStartX = 0;
    var touchEndX = 0;

    if (zoomModal) {
      zoomModal.addEventListener('touchstart', function(e) {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });

      zoomModal.addEventListener('touchend', function(e) {
        touchEndX = e.changedTouches[0].screenX;
        handleSwipe();
      }, { passive: true });
    }

    function handleSwipe() {
      // While magnified, horizontal drags are panning, not navigation.
      if (isZoomed() || didPan) return;
      var swipeThreshold = 50;
      var diff = touchStartX - touchEndX;

      if (Math.abs(diff) > swipeThreshold) {
        if (diff > 0) {
          // Swipe left - next image
          updateZoomImage(currentIndex + 1);
        } else {
          // Swipe right - previous image
          updateZoomImage(currentIndex - 1);
        }
      }
    }

    // Care accordion behavior
    var careTriggers = document.querySelectorAll('.care-section__trigger');

    function setCareSectionState(trigger, isOpen) {
      var section = trigger.closest('.care-section');
      var panel = section ? section.querySelector('.care-section__panel') : null;

      trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if (panel) {
        if (isOpen) {
          panel.classList.add('is-open');
        } else {
          panel.classList.remove('is-open');
        }
      }
    }

    careTriggers.forEach(function(trigger) {
      trigger.addEventListener('click', function() {
        var isExpanded = trigger.getAttribute('aria-expanded') === 'true';

        careTriggers.forEach(function(otherTrigger) {
          setCareSectionState(otherTrigger, false);
        });

        setCareSectionState(trigger, !isExpanded);
      });
    });

    // Generic modal open/close helper
    function setupModal(buttonId, modalId, closeId) {
      var button = document.getElementById(buttonId);
      var modal = document.getElementById(modalId);
      var closeBtn = document.getElementById(closeId);

      if (button && modal) {
        button.addEventListener('click', function() {
          modal.classList.add('active');
          document.body.style.overflow = 'hidden';
        });

        if (closeBtn) {
          closeBtn.addEventListener('click', function() {
            modal.classList.remove('active');
            document.body.style.overflow = 'auto';
          });
        }

        modal.addEventListener('click', function(e) {
          if (e.target === modal) {
            modal.classList.remove('active');
            document.body.style.overflow = 'auto';
          }
        });

        document.addEventListener('keydown', function(e) {
          if (e.key === 'Escape' && modal.classList.contains('active')) {
            modal.classList.remove('active');
            document.body.style.overflow = 'auto';
          }
        });
      }
    }

    // Care modal
    setupModal('care-button', 'care-modal', 'care-modal-close');

    // Material modal
    setupModal('material-button', 'material-modal', 'material-modal-close');
  });

  } catch(e) { console.error(e); }
})();
})();
